import { generateContext } from '../../utils'
import { DeviceDataType, DeviceListType, DeviceStationsType, DeviceType } from '../DeviceConfig'
import {
    StationData,
    StationDirections,
    StationName,
    StationNameList,
    TrajectoryConfigurationMode
} from './station_types'

import { GetStationByParkingLotQuery } from '../Lot/lot-types'
import { ODDisplayOverrideConfig } from './ODDisplayOverride'

export interface StationContextInterface {
    stations: StationNameList | undefined
    // The station list has to land before a `?stationName=` param can be resolved to a selection, so
    // views need to tell "still fetching" apart from "nothing selected".
    loadingStations: boolean
    loadingStationData: boolean
    setSelectedStation: (station: StationName | null | undefined) => void
    selectedStation: StationName | undefined | null
    selectedStationData: StationData | undefined
    selectedStationDeviceStations: DeviceStationsType | undefined
    info: {
        deviceName?: string | null
    }
    deviceData: DeviceDataType | undefined
    selectedDevice?: DeviceType | null
    devices: DeviceListType
    saveStation: (device_direction: StationDirections, device_uuid?: string | null | undefined) => void
    loadingSaveStation: boolean
    setStationEnabled: (enabled: boolean) => void
    loadingUpdateStationEnabled: boolean
    saveDiffConfig: (diff_config: any) => void
    deleteStation: () => void
    isDeletingStation: boolean
    saveStationConfig: (enabledAutoWhitelisting: boolean, numberOfDays: number | null) => void
    saveStationConfigFilter: (newFilter: any) => void
    configurationMode: TrajectoryConfigurationMode
    setConfigurationMode: (mode: TrajectoryConfigurationMode) => void
    loadingSaveStationConfigFilter: boolean
    loadingDeviceConfigSave: boolean
    loadingSaveStationConfig: boolean
    stationsInLot: GetStationByParkingLotQuery | undefined
    getLotId: () => string | undefined
    saveODDisplayOverrideHandler: (newODConfig: ODDisplayOverrideConfig) => void
    loadingSaveODDisplayOverride: boolean
}
const [StationContext, StationProvider] = generateContext<StationContextInterface>()
export { StationContext, StationProvider }
